import {
    CriteresFactureDtoInput,
    FactureDtoInput,
    ListeFacturesEtListeReglementsModelDtoInput
} from 'src/graphql/generated-types';
import { TypeReglement } from 'src/app/board/activity/activity.constants';

export interface SharedAdvancedSettlement {

    paymentType: TypeReglement;

    activityId: number;

    invoiceId: number;

    invoicesListIdForCriterias?: number[];

    shouldDisplayHiddenInvoice? : boolean;

    thirdId: number;
}

const stateName = '[Shared][AdvancedSettlement] ';

export class SharedAdvancedSettlementGetInvoicesListAction {
    static readonly type = stateName + 'GetInvoicesList';

    constructor(public criterias: CriteresFactureDtoInput) {
    }
}

export class SharedAdvancedSettlementSetInformationsAction {
    static readonly type = stateName + 'SetInformations';

    constructor(public paymentInfos: SharedAdvancedSettlement) {
    }
}

export class SharedAdvancedSettlementSaveInvoiceWithDepositsAction {
    static readonly type = stateName + 'SaveInvoiceWithDeposits';

    constructor(public invoice: FactureDtoInput) {
    }
}

export class SharedAdvancedSettlementSaveAdvancedSettlementAction {
    static readonly type = stateName + 'SaveAdvancedSettlement';

    constructor(public payment: ListeFacturesEtListeReglementsModelDtoInput) {
    }
}
